<template>
	<div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)">
		<div class="ld-panel-title">
			<router-link to="/hosts" class="back-btn"><span></span>参数模板设置</router-link>
		</div>
		<div class="ld-panel-main">
			<div class="template">
				<div style="float: left;">
					<el-select v-model="templateValue" placeholder="切换参数模板" style="width: 300px" @change="seeChange">
					    <el-option v-for="item in templateOptions" :key="item.template_id" :value="item.template_id" :label="item.name"></el-option>
					</el-select>
					<el-button type="primary" style="margin-left: 10px;" @click="templateChange">切换成所选参数模板</el-button>
				</div>
				当前参数模板：<el-text type="primary">{{templateData.name}}</el-text>
			</div>
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column property="name" label="参数名称" />
				<el-table-column property="value_type" label="值类型" />
				<el-table-column property="value" label="参数值" />
				<el-table-column property="type" label="应用类型" />
				<el-table-column property="data_type" label="数据类型" />
				<el-table-column property="source" label="参数源" />
			</el-table>
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted } from 'vue';
	import { useRouter } from 'vue-router';
	import { fetchtemplateList,templateSet,restart } from '@/api/host';
	import { fetchList } from '@/api/template';
	import { ElMessage, ElMessageBox } from 'element-plus'
	
	const router = useRouter();
	const fullscreenLoading = ref(false);
	const templateValue = ref('');
	const templateOptions = ref('');
	const submitDisabled = ref(false);
	const loading = ref(true);
	const templateId = ref('');
	const exampleId = ref('');
	const typeText = ref('');
	const templateData = ref('');
	const tableData = ref();
	
	const templatelist = () => {
		const param = {'page':1,'size':999}
		fetchList(param).then((res) => {
			templateOptions.value = res.data.list;
		})
	}
	const fetchListF = () => {
		const param = {'template_id':templateId.value,'instance_id':exampleId.value}
		fetchtemplateList(param).then((res) => {
			tableData.value = res.data.details_list;
			templateData.value = res.data;
			loading.value = false;
		})
		templatelist()
	}
	const seeChange = (val) => {
		const param = {'template_id':val}
		fetchtemplateList(param).then((res) => {
			tableData.value = res.data.details_list;
		})
	}
	const templateChange = () => {
		if (templateValue.value == '') {
			ElMessage({
				type: 'error',
				offset:70,
				message: '请选择参数模板',
			})
		}else{
			fullscreenLoading.value = true;
			const param = {'template_id':templateValue.value,'instance_id':exampleId.value}
			const params = {"instance_id": exampleId.value}
			templateSet(param).then((res) => {
				if(res.code === 200){
					templateId.value = res.data;
					ElMessageBox.confirm(
						'更换模板后需要重启实例才能生效，是否立即重启？',
						'提示',
						{
							confirmButtonText: '立即重启',
							cancelButtonText: '稍后重启',
							closeOnClickModal: false,
							showClose:false,
							type: 'warning',
						}
					)
					.then(() => {
						loading.value = true;
						restart(params).then((res) => {
							if(res.code === 200){
								ElMessage({
									type: 'success',
									message: res.msg,
								})
								loading.value = false;
							}
						})
					})
					.catch(() => {
						
					})
					fetchListF()
				}
				fullscreenLoading.value = false;
			});
		}
	}
	
	onMounted(() => {
		if(router.currentRoute.value.query){
			templateId.value = router.currentRoute.value.query.template;
			exampleId.value = router.currentRoute.value.query.example;
		}
		fetchListF()
	});
</script>

<style lang="scss" scoped>
	.template{
		margin-bottom: 24px;
		line-height: 35px;
		text-align: right;
		overflow: hidden;
	}
	.search-main{float: right;}
</style>
